export default {
      id: "domaine-usage",
      viewBox: "0 0 26 26",
      url: "../../../plugins/creasit-builder/assets/dist/images/" + "sprite.svg#domaine-usage",
      toString: function () {
        return this.url;
      }
    }